import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const definition = {
    validation: {
        returns: z.object({
            mean: anyImageOpResult,
            variance: anyImageOpResult,
        }),
        parameters: z.object({
            sourceImage: anyImageOpResult,
        }),
    },
}
